import { JSX, useMemo } from "react";
import { useParams } from "react-router-dom";

export type ResourcePageContentProps = {
	id: number;
};

export type ResourcePageProps = {
	render: (props: ResourcePageContentProps) => JSX.Element;
};

export default function ResourcePage(
	props: Readonly<ResourcePageProps>
): JSX.Element {
	const { id } = useParams<{ id: string }>();

	const resourceId = useMemo(() => (id ? parseInt(id, 10) : undefined), [id]);

	if (resourceId === undefined || isNaN(resourceId)) {
		return <></>;
	}

	return props.render({ id: resourceId });
}
